export const exportButtonGroupStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginLeft: "auto",
};

const baseExportBtn = {
  border: "none",
  borderRadius: "6px",
  padding: "8px 12px",
  fontSize: "10px",
  fontWeight: 600,
  letterSpacing: "1px",
  cursor: "pointer",
  color: "#ffffff",
};

export const exportExcelButtonStyle = {
  ...baseExportBtn,
  background: "#009688",
};

export const exportPdfButtonStyle = {
  ...baseExportBtn,
  background: "#dc2626",
};
